import { render, staticRenderFns } from "./InputClipboard.vue?vue&type=template&id=389a7777&scoped=true"
import script from "./InputClipboard.vue?vue&type=script&lang=js"
export * from "./InputClipboard.vue?vue&type=script&lang=js"
import style0 from "./InputClipboard.vue?vue&type=style&index=0&id=389a7777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a7777",
  null
  
)

export default component.exports